






















import { Tab, Tabs } from 'vant';
import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import SearchInput from '@/components/SearchInput.vue';
import { namespace, State } from 'vuex-class';
import { IState, HealthListParam } from './store/types';
import { getBaseinfo } from './api/index';
import { Banner } from '@/components';
import * as mutationTypes from './store/mutation-types';
import * as config from './config';

const Module = namespace('AssociationEcologyMeeting2019');
Vue.use(Tab).use(Tabs);
@Component({
  components: {
    VoteList,
    SearchInput,
    Banner,
  },
})
export default class List extends Vue {
  @Module.State('healthList') healthListData!: object;
  @Module.State('finished') finished!: boolean;
  @Module.State('loading') healthLoading!: boolean;
  @Module.State('searchPage') searchPage!: number;
  @Module.State('loadStatus') loadStatus!: number;
  @Module.State('type') type!: number;
  @Module.Action searchHealthList!: (param: HealthListParam) => void;
  @Module.Mutation(mutationTypes.CLEAN_LIST_DATA) cleanData!: () => void;
  @Module.Mutation(mutationTypes.CHANGE_LOADSTATUS_DATA)
  changeLoadstatus!: (loadstatus: number) => void;
  options = config.OPTHINES;
  SearchData = '';
  ifChangeType = false;
  ifSearch = false;
  baseInfo: object = {};
  created() {
    getBaseinfo().then((res: any) => (this.baseInfo = res.data));
    this.cleanData();
    this.changeLoadstatus(1);
  }
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索
  startSearch() {
    this.ifSearch = true;
    this.cleanData();
    this.searchHealthList({
      type: 10,
      page: this.searchPage,
      search: this.SearchData,
    });
    // setTimeout(() => {
    //   this.onLoad();
    // }, 500);
  }
  goBack() {
    this.ifChangeType = !this.ifChangeType;
    this.$router.go(-1);
  }
}
